import i18n from "../i18n";

const SelectFieldService = {
    convertListToSelectOptions: (list, translatePrefix = "") => {
        const options = [];
        for (const element of list) {
            options.push({
                id: element,
                name: i18n.t(`${translatePrefix}${element}`),
            });
        }
        return options.sort((a, b) => a.name.localeCompare(b.name));
    },

    getOptionsYesOrNo: () => [
        { id: true, name: i18n.t("yes") },
        { id: false, name: i18n.t("no") },
    ],

    getLabelOptionsTrueOrFalse: (value) => {
        return value ? i18n.t("true") : i18n.t("false");
    },

    getLabelOptionsYesOrNo: (value) => {
        return value ? i18n.t("yes") : i18n.t("no");
    },
};

export default SelectFieldService;
